import { render, staticRenderFns } from "./GridDictionaries.vue?vue&type=template&id=4fbed34c&"
import script from "./GridDictionaries.vue?vue&type=script&lang=js&"
export * from "./GridDictionaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fbed34c')) {
      api.createRecord('4fbed34c', component.options)
    } else {
      api.reload('4fbed34c', component.options)
    }
    module.hot.accept("./GridDictionaries.vue?vue&type=template&id=4fbed34c&", function () {
      api.rerender('4fbed34c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dictionaries/grid/GridDictionaries.vue"
export default component.exports